import { ref, toRef, computed, watch } from 'vue'

const selectors = ref([
    {
        text: 'Images',
        value: 'images',
        selected: true
    },
    {
        text: 'Video',
        value: 'videos',
        selected: false
    },
    {
        text: 'Music',
        value: 'audios',
        selected: false
    }
])
const loadedVideos = ref([])

export const useMediaOrganizer = (props) => {
    const images = toRef(props, 'images')
    const videos = toRef(props, 'videos')
    const profilePicIndx = toRef(props, 'profilePicIndx')

    watch(
        [() => videos.value, () => loadedVideos.value],
        ([videos, loadedVideos]) => {
            if (videos.length === loadedVideos.length) return

            if (videos.length > loadedVideos.length) {
                videos.forEach((video) => {
                    if (loadedVideos.some((loadedVideo) => loadedVideo.name === video.name)) return
                    loadedVideos.push({
                        loaded: false,
                        playing: false,
                        name: video.name,
                        src: mediaURL(video),
                        duration: null
                    })
                })
            } else {
                loadedVideos.splice(0)
            }
        },
        { immediate: true }
    )
    const hoverIndex = ref(null)

    const selected = computed(() => {
        return selectors.value.find((s) => s.selected).value
    })
    function select(selector) {
        selectors.value.forEach((s) => {
            if (s.value === selector.value) {
                s.selected = true
            } else {
                s.selected = false
            }
        })
    }

    function deleteImage(indx) {
        const profile = images.value[profilePicIndx.value]
        images.value.splice(indx, 1)

        profilePicIndx.value = images.value.indexOf(profile)
        hoverIndex.value = null
    }

    function loadVideo(video, refs) {
        if (video.loaded) return

        video.loaded = true

        if (loadedVideos.value.every((video) => video.loaded)) {
            loadVideoDuration(refs)
        }
    }
    function loadVideoDuration(refs) {
        loadedVideos.value.forEach((video, indx) => {
            video.duration = _convertToMinutes(refs[indx].duration)
        })
    }
    function mediaURL(media) {
        if (media instanceof File) {
            return URL.createObjectURL(media)
        } else {
            return media.src
        }
    }

    function _convertToMinutes(seconds) {
        let finalSeconds = Math.floor(seconds % 60)

        if (finalSeconds >= 0 && finalSeconds < 10) {
            finalSeconds = `0${finalSeconds}`
        }
        return `${(seconds / 60) | 0}:${finalSeconds}`
    }
    function deleteVideo(indx) {
        videos.value.splice(indx, 1)
        loadedVideos.value.splice(indx, 1)
        hoverIndex.value = null
    }

    return {
        hoverIndex,
        selectors,
        selected,
        select,

        deleteImage,

        loadedVideos,
        loadVideo,
        deleteVideo
    }
}
